import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import Uploader from "../../../general/uploader";
import { Media } from "../../../../interfaces/media";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { emptyProgramMedia, ProgramMedia } from "../../../../interfaces/program";
import { getProgramMediaSingle, updateProgramMedia } from "../../../../services/program";

interface ProgramMediaEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramMediaEdit(props: ProgramMediaEditProps) {
    const [programMedia, setProgramMedia] = useState<ProgramMedia>(emptyProgramMedia);
    const [media, setMedia] = useState<Media[]>([]);

    useEffect(() => {
        getProgramMediaSingle(props.id)
            .then(response => {
                const newMedia = response.data.media.map((m: Media) => {
                    return m;
                });
                setMedia(newMedia);
                setProgramMedia(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        if (media.length == 0) {
            alert(t("You must upload one video, image or document"));
            return false;
        }

        const body: any = {
            id: event.target.id.value,
            program_id: event.target.program_id.value,
            name: event.target.name.value,
            description: event.target.description.value,
            media: media.length > 0 ? media[0].id : 0
        }

        if (programMedia.folder_id !== null) {
            body.folder_id = programMedia.folder_id;
        }
        updateProgramMedia(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("single_image_warning"));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }
    
    return (
        <Modal className="progam-media-edit-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Edit media") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { programMedia.id == 0 && 
                    <LoadingSpinner />
                }
                { programMedia.id != 0 && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group className="mb-3" controlId="id">
                                <Form.Control type="hidden" name="id" required 
                                    defaultValue={ programMedia.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="program_id">
                                <Form.Control type="hidden" name="program_id" required 
                                    defaultValue={ programMedia.program_id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ programMedia.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea"
                                    defaultValue={ programMedia.description } />
                            </Form.Group>
                            <Form.Group className="mb-3 media-field" controlId="media">
                                <Uploader title={ t("video_upload_message") }
                                    media={ media } save={ handleMediaEventUpload } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}